// extracted by mini-css-extract-plugin
export default {"container":"router_container__MZsTS"};